import React from 'react';
import { DataTableColumnProps } from 'Components/Core/DataTable/types';

const DataTableColumn = <T extends object>({ children }: DataTableColumnProps<T>) => {
  return <>{children}</>;
};

export default DataTableColumn;
